<template>
  <Loading v-if="componentLoading" :style="style" />
  <template v-else>
    <Chart class="map-2d-chart" ref="chartComponent" :option="chartConfig" :style="style" />
  </template>
  <slot></slot>
</template>

<script lang="ts" setup>
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"

// 当前模块引入
import Loading from "@p-v/packages/Loading.vue"
import { ref, provide, watch } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import { EChartsOption } from "echarts"
import * as echarts from "echarts"
import config from "@p-v/packages/Map/GeoMap/config"
// import mapData from "china-map-echarts"
import codeToNameMap from "./codeToNameMap.json"
import { requestAdapter } from "@p-v/api"

const mapData: any = {}

defineOptions({
  name: "PftGeoMap",
})

const findMap = (name: string) => {
  const keys = Object.keys(codeToNameMap)
  const values = Object.values(codeToNameMap)
  const index = values.indexOf(name)
  return keys[index]
}

const chartComponent = ref<InstanceType<typeof Chart>>()

interface ComponentProps {
  style: { [key: string]: string }
  option?: EChartsOption
  position: string
}

const props = withDefaults(defineProps<ComponentProps>(), {
  style: () => ({}),
  option: () => ({}),
  position: "中国",
})

const componentLoading = ref<boolean>(true)

provide("coordinateSystem", "geo")

const chartConfig = ref(cloneDeep(defaultsDeep(props.option, config)))

const updateSeries = (data: { id: string }, opt: any) => {
  console.log("updateSeries", data)
  const { id } = data
  const series = chartConfig.value.series
  const index = series.findIndex((item: any) => item.id === id)
  if (index > -1) {
    series.splice(index, 1)
    chartConfig.value.series = series
  } else {
    chartConfig.value.series.push(data)
  }
  if (opt) {
    if (opt.visualMap) chartConfig.value.visualMap = opt.visualMap
  }
}

provide("updateSeries", updateSeries)
provide("map", props.position)

const loading = () => {
  componentLoading.value = true
}

watch(
  () => chartConfig.value,
  val => {
    console.log("chartConfig update", val)
  },
  {
    deep: true,
  },
)

const getMapData = async (mapCode: string) => {
  if (mapData[`map_${mapCode}`]) {
    return mapData[`map_${mapCode}`]
  }
  const res = await requestAdapter({
    url: `https://src-cdn.z-si.com/12301/map/${mapCode}.json`,
    method: "GET",
  })
  console.log("getMapData", res)
  mapData[`map_${mapCode}`] = res
  return res
}

const setData = async (data: ComponentProps) => {
  const pos = data.position || props.position
  const mapCode = findMap(pos)
  if (!mapCode) {
    console.error("未找到对应地图")
    return
  }
  const mapItem = await getMapData(mapCode)
  echarts.registerMap(props.position, mapItem)
  chartConfig.value.geo = {
    type: "map",
    map: props.position, //chinaMap需要与registerMao中的变量名称保持一致
    raom: false,
    itemStyle: {
      normal: {
        areaColor: "rgb(4,46,84)",
        borderColor: "#fff",
      },
      emphasis: {
        areaColor: "#389bb7", //鼠标指上市时的颜色
      },
    },
    label: {
      normal: {
        position: "bottom",
        show: false, //不显示
      },
      emphasis: {
        show: true,
        textStyle: {
          // 地图上散点的字体样式
          fontSize: 12,
          fontWeight: "400",
          color: "#fff", // 点上字的颜色
        },
      },
    },
  }
  const { option } = data
  chartConfig.value = defaultsDeep(option || {}, props.option, config, chartConfig.value)
  console.log("chartConfig", chartConfig.value)
  componentLoading.value = false
}

defineExpose({ setData, loading })
</script>

<style lang="scss">
.map-2d-chart {
  height: 100%;
  position: relative;
}
</style>
